import { ListItemSkeleton, SectionHeadingSkeleton } from "@/components/Skeleton";

export default function ExperienceIndexAnswersSkeleton() {
  return (
    <div className="flex flex-col gap-6" data-testid="career-plan-ei-answers-skeleton">
      <SectionHeadingSkeleton />
      <ListItemSkeleton rows={6} />
    </div>
  );
}
